// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Icon from '@ff/ui/Icon';
import { FF_ICONS, FF_ICONS_SOCIAL } from 'shared/ff-icons';
import IconGallery from './IconGallery';
import { S, DARK } from '~/app/ui/tokens';

type Props = {
  classes: Object,
  value: ?string,
  onChange: (newVal: ?string) => void,
  socialIcons: ?boolean
};

class IconPicker extends React.Component {
  props: Props = this.props;
  state = {
    iconGalleryOpen: false
  }

  handleSave = (iconClassName) => {
    this.props.onChange(iconClassName);
    this.handleClose();
  }

  handleClose = () => {
    this.setState({ iconGalleryOpen: false });
  }

  openGallery = () => {

  }

  render = () => {
    const { classes: c, value, socialIcons } = this.props;
    const hasValue = typeof value === 'string' && value.trim().length > 0;

    return (
      <div className={c.iconPicker}>
        <div className={c.displayContainer}>
          {hasValue && <Icon name={value} className={c.displayIcon} />}
          {value}
        </div>
        <div className={c.actionGroup}>
          <a
            className={c.actionBtn}
            onClick={() => this.setState({ iconGalleryOpen: true })}
          >
            <i className="material-icons">collections</i>
            Choose From Icon Gallery
          </a>
        </div>
        { this.state.iconGalleryOpen &&
          <IconGallery
            icons={socialIcons ? FF_ICONS_SOCIAL : FF_ICONS}
            onClose={this.handleClose}
            onSave={this.handleSave}
          />
        }
      </div>
    );
  }
}

const styles = {
  textInput: {
    flexGrow: '2',
    border: '1px solid hsl(0, 0%, 90%)',
    padding: '10px 10px',
    borderRadius: '3px',
    fontSize: '13px',
    color: 'hsl(0, 0%, 20%)',
    fontWeight: '400',
    width: '100%',
    outline: 'none',
    '&:disabled': {
      background: 'hsl(0, 0%, 90%)',
      cursor: 'not-allowed'
    },
    [DARK]: {
      borderColor: S.fieldLine,
      background: S.field,
      color: S.fg,
      '&:disabled': { background: S.chromeHover }
    }
  },
  displayContainer: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: 'hsl(0, 0%, 20%)',
    [DARK]: { color: S.fg }
  },
  displayIcon: {
    fontSize: '38px',
    marginRight: '10px'
  },
  actionGroup: {
    display: 'flex',
    marginTop: '10px'
  },
  actionBtn: {
    fontFamily: '"Helvetica Neue", Helvetica, "Segoe UI", Arial, freesans, sans-serif',
    fontSize: '12px',
    cursor: 'pointer',
    color: 'hsl(0, 0%, 30%)',
    display: 'flex',
    alignItems: 'center',
    marginRight: '20px',
    '& > .material-icons': {
      fontSize: '14px',
      color: 'hsl(0, 0%, 50%)',
      paddingRight: '3px'
    },
    [DARK]: { color: S.fg, '& > .material-icons': { color: S.muted } }
  }
};

export default injectSheet(styles)(IconPicker);
